export default __webpack_public_path__ + "static/base-agency-balthazaurus-scroll-6f0366714cd1cce5399eb50da260f217.mp4";